import { render } from "./Forgot_Password.vue?vue&type=template&id=1ff99cf0&scoped=true"
import script from "./Forgot_Password.vue?vue&type=script&lang=js"
export * from "./Forgot_Password.vue?vue&type=script&lang=js"

import "./Forgot_Password.vue?vue&type=style&index=0&id=1ff99cf0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff99cf0"]])

export default __exports__